// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2xLMw","inputDescription":"styles_inputDescription__2xkvO"};